import React from "react";

export default function StatCard({
  title,
  value,
  icon: Icon,
  accent = "indigo",
}) {
  // Icon accent color (no background)
  const iconColor =
    {
      indigo: "text-indigo-600 dark:text-indigo-400",
      green: "text-green-600 dark:text-green-400",
      blue: "text-blue-600 dark:text-blue-400",
      purple: "text-purple-600 dark:text-purple-400",
      red: "text-red-600 dark:text-red-400",
    }[accent] || "text-indigo-600 dark:text-indigo-400";

  return (
    <div className="flex items-center justify-between p-6 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-bg-darkSecondary shadow-sm min-h-28 transition-colors hover:bg-gray-50 dark:hover:bg-bg-darkPrimary">
      <div className="flex flex-col gap-2">
        <span className="text-3xl font-semibold text-gray-800 dark:text-white">
          {title}
        </span>
        <span className="text-xl font-semibold text-gray-900 dark:text-white">
          {value}
        </span>
      </div>
      {Icon ? <Icon className={`text-3xl ${iconColor}`} /> : null}
    </div>
  );
}
